import { updateStopFailureNotification } from '../../../../notifications/visits';
import {
  getReschedulingStopMessageKey,
  rescheduleStopFailNotification,
  rescheduleStopSuccessNotification,
} from '../../../../notifications/scheduling/rescheduleStop';
import { ProjectStopRescheduledDtoModelType } from '../../models';
import getAppEnv from '../../utils/getAppEnv';
import getAppRoot from '../../utils/getAppRoot';

type UIActions = {
  orderForm: any;
  setOrderForm: (form: any) => void;
  closeOrderForm: () => void;
  selectVisitAndRoute: (id: string, routeId: string) => void;
  selectVisit: (id: string) => void;
  selectRoute: (routeId?: string) => void;
};

const handleSuccess = (
  id: string, visitName: string, routeIdStr: string,
  appEnv: ReturnType<typeof getAppEnv>, ui: UIActions,
) => {
  if (ui.orderForm.visit?.id === id && ui.orderForm.visible) {
    ui.closeOrderForm();
  }

  appEnv.notification(rescheduleStopSuccessNotification(id, visitName, () => ui.selectVisitAndRoute(id, routeIdStr)));
};

const handleFailure = (
  id: string, visitName: string, routeIdStr: string,
  appEnv: ReturnType<typeof getAppEnv>, ui: UIActions,
) => {
  ui.setOrderForm({ ...ui.orderForm, saving: false });

  appEnv.notification(updateStopFailureNotification(id, visitName, () => {
    ui.selectVisit(id);
    ui.selectRoute(routeIdStr);
  }));

  appEnv.notification(rescheduleStopFailNotification(id, visitName, () => {
    ui.selectVisit(id);
    ui.selectRoute(routeIdStr);
  }));
};

const projectStopRescheduledHandler = ({
  store, pendingSolution, success,
}: ProjectStopRescheduledDtoModelType) => {
  const routeId = pendingSolution.assignAction?.targetRouteId;

  if (pendingSolution.assignAction.visitId != null && routeId != null) {
    const appEnv = getAppEnv(store);
    const appStore = getAppRoot(store);
    const { ui } = appStore;
    const id = String(pendingSolution.assignAction.visitId);
    const routeIdStr = String(routeId);
    const { visitName } = pendingSolution.assignAction;

    if (!ui.orderForm.visible) {
      appEnv.closeMessage(getReschedulingStopMessageKey(id));
    }

    if (success) {
      handleSuccess(id, visitName, routeIdStr, appEnv, ui);
    } else {
      handleFailure(id, visitName, routeIdStr, appEnv, ui);
    }
  }

  return () => {
    store.assignActionStatusDtos.delete(pendingSolution.assignAction.id);
    store.solutionStatusOnlyDtos.delete(pendingSolution.id);
  };
};

export default projectStopRescheduledHandler;
